// Vue 3: Use createStore instead of new Vuex.Store
import { createStore } from "vuex"

import { abilityPlugin, ability as appAbility } from "./ability"
// Modules
import app from "./app"
import appConfig from "./app-config"
import auth from "./auth.module"
import storage from "./storage"
import verticalMenu from "./vertical-menu"

export const ability = appAbility

// Vue 3: Use createStore
export default createStore({
  state: {
    // Document
    recounttreasuremoneyFilter: {},
    cashrequirementFilter: {},
    changemoneyFilter: {},
    changeusercashboxFilter: {},
    clientpaymentFilter: {},
    currencyexchangeFilter: {},
    documentcontrolFilter: {},
    documentheldFilter: {},
    incomecashorderFilter: {},
    incomecashorderoutofbalanceFilter: {},
    incomecollectionbagFilter: {},
    incomerecountactFilter: {},
    incometreasuremoneyFilter: {},
    limitFilter: {},
    offbalancerequirementFilter: {},
    outcomecashorderoutofbalanceFilter: {},
    outgoingcashorderFilter: {},
    outofbalancerestFilter: {},
    recountactFilter: {},
    reinforcementFilter: {},
    requirementFilter: {},
    returnemptybagFilter: {},
    sendtreasuremoneyFilter: {},
    cashorderrestFilter: {},
    documentcontrolcurrencycashFilter: {},
    documentcontrolvashFilter: {},

    // Info
    accountsplanFilter: {},
    allowtransactionFilter: {},
    bankFilter: {},
    bankcategoryFilter: {},
    bankdateFilter: {},
    banknoteFilter: {},
    banktypeFilter: {},
    branchFilter: {},
    cashboxFilter: {},
    citizenshipFilter: {},
    clientcontractFilter: {},
    clientpaymenttypeFilter: {},
    collectionbagFilter: {},
    collectorFilter: {},
    contractorFilter: {},
    countryFilter: {},
    currencyFilter: {},
    currencyrateFilter: {},
    departmentFilter: {},
    districtFilter: {},
    documentcontroltypeFilter: {},
    nationalityFilter: {},
    paymentsymbolFilter: {},
    paymentsymbolpurposeFilter: {},
    paymenttypeFilter: {},
    positionFilter: {},
    positionclassFilter: {},
    regionFilter: {},
    settlementaccountFilter: {},
    strictreportingformFilter: {},
    unitofmeasureFilter: {},
    virtualsettlementaccountFilter: {},
    organizationFilter: {},
    roleFilter: {},
    userFilter: {},
    transfercomissionfeeFilter: {},
    transfersystemtypeFilter: {},
    currencyexchangelimitFilter: {},
    customerFilter: {},
    vashlimitFilter: {},
    checktemplateFilter: {},
    recountActForAtmFilter: {},
    recountActForAtm2Filter: {},
    recountActForAtmEditFilter: {},
    atmEventLogFilter: {},
    holidayFilter: {},

    tokenLifeTime: null,
    timeForUseLastAPI: 0,
    timeRedirectLogin: null,
    UnreadDocCount: {
      offbalancerequirement: 0,
      outcomecashorderoutofbalance: 0,
      incomecashorderoutofbalance: 0,
      cashrequirement: 0,
      outgoingcashorder: 0,
      incomecashorder: 0,
      reinforcement: 0,
      sendtreasuremoney: 0,
      cashrequirementbycurrency: 0,
    },
    enableBanknoteInClientSide: false,

    webSocket: null,
    announcements: [],
    isGlobalLoading: false,
    globalLoadingText: "Iltimos kuting...",
    globalLoadingShowAfterTime: 5000,

    lastRequestTime: null,
    WSConnection: null,
    is403error: false,

    userInfo: JSON.parse(localStorage.getItem("userInfo")) || null,
  },
  plugins: [
    storage({
      storedKeys: ["rules"],
      destroyOn: ["auth/logoutSuccess"],
    }),
    abilityPlugin,
  ],
  getters: {
    getUserInfo(state) {
      return JSON.parse(localStorage.getItem("user_info")) || state.userInfo
    },
    getUnreadDocCount(state) {
      return state.UnreadDocCount
    },
    getWebSocket(state) {
      return state.webSocket
    },
    getGlobalLoadingText(state) {
      return state.globalLoadingText
    },
    getGlobalLoadingShowAfterTime(state) {
      return state.globalLoadingShowAfterTime
    },
    getIsGlobalLoading(state) {
      return state.isGlobalLoading
    },
    getLastRequestTime(state) {
      return state.lastRequestTime
    },
    getWSConnection(state) {
      return state.WSConnection
    },
  },
  mutations: {
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo
    },
    SET_UNREAD_DOC_COUNT(state, count) {
      state.UnreadDocCount = count
    },
    SET_ENABLE_BANKNOTE_IN_CLIENT_SIDE(state, value) {
      state.enableBanknoteInClientSide = value
    },
    SET_ANNOUNCEMENTS(state, announcements) {
      state.announcements = announcements
    },
    SET_LAST_REQUEST_TIME(state, time) {
      state.lastRequestTime = time
    },
    SET_403_ERROR(state, value) {
      state.is403error = value
    },
  },
  modules: {
    auth,
    app,
    appConfig,
    verticalMenu,
  },
  // strict: import.meta.env.DEV, // Disabled during Vue 3 migration - enable later and fix violations
})
